var _polygon, _polygon2, _polygon3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f55376",
    points: "37,6 11,6 11,30 24,36 37,42"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f55376",
    points: "11,6 37,6 37,30 24,36 11,42"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eb0000",
    points: "11,6 11,30 24,36 31.5,32.538 37,25 37,6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fadb00",
    points: "37,29.768 48,21 26,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fadb00",
    points: "37,29.732 43.957,34 44,34 37,14 30,34 30.044,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5bc00",
    points: "39.45,21 34.55,21 32.685,26.329 36.974,29.748 37,29.732 37.026,29.748 41.315,26.329"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorites);
export default __webpack_public_path__ + "static/media/icon-favorites.2495ccd975b888cc4769d2ba73c6f06f.svg";
export { ForwardRef as ReactComponent };